export default "__VITE_ASSET__BQk$HmZb__"